import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, MailIcon, LightbulbIcon, ActivityIcon } from 'lucide-react';
export function ProofSection() {
  const changes = [{
    icon: <CalendarIcon className="w-6 h-6 text-cyan-neon" data-id="element-183" />,
    text: 'Organizarás tu semana en 10 minutos o menos'
  }, {
    icon: <MailIcon className="w-6 h-6 text-cyan-neon" data-id="element-184" />,
    text: 'Redactarás correos y propuestas en la mitad del tiempo'
  }, {
    icon: <LightbulbIcon className="w-6 h-6 text-cyan-neon" data-id="element-185" />,
    text: 'Generarás ideas de contenido en bloques rápidos'
  }, {
    icon: <ActivityIcon className="w-6 h-6 text-cyan-neon" data-id="element-186" />,
    text: 'Tendrás tu rutina personal, desde ejercicio hasta comidas, optimizada con IA'
  }];
  return <section className="py-24 px-6 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-600 relative overflow-hidden" data-id="element-187">
      {/* Background Glows */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-neon/5 rounded-full blur-[100px] pointer-events-none" data-id="element-188" />

      <div className="max-w-4xl mx-auto" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-190">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-191">
            ¿Qué cambia en <span className="text-cyan-neon" data-id="element-192">7 días?</span>
          </h2>
          <p className="text-xl text-slate-300" data-id="element-193">
            En la primera semana aplicando esta guía:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-194">
          {changes.map((change, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-900/60 border border-cyan-neon/20 rounded-2xl p-6 flex items-start gap-4 hover:bg-navy-900/80 transition-colors shadow-lg backdrop-blur-sm" data-id="element-195">
              <div className="bg-cyan-neon/10 p-3 rounded-xl shrink-0" data-id="element-196">
                {change.icon}
              </div>
              <p className="text-slate-200 text-lg font-medium pt-1" data-id="element-197">
                {change.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-r from-cyan-neon/10 via-cyan-neon/20 to-cyan-neon/10 border border-cyan-neon/30 rounded-2xl p-8" data-id="element-198">
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-199">
            Y lo más importante:{' '}
            <span className="text-cyan-neon" data-id="element-200">
              recuperarás horas valiosas para lo que realmente importa.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}